<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">
    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'filter.start' | translate}} {{'kf-reporting.year' |translate}}</mat-label>
      <input matInput type="number" [formControl]="startYearControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'filter.end' | translate}} {{'kf-reporting.year' |translate}}</mat-label>
      <input matInput type="number" [formControl]="endYearControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'kf-reporting.UNU-key-set' |translate}}</mat-label>
      <input matInput type="text" [formControl]="unuKeyControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'kf-reporting.key-figure-category-set' |translate}}</mat-label>
      <input matInput type="text" [formControl]="kfCategoryControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'kf-reporting.collection-stream-set' |translate}}</mat-label>
      <input matInput type="text" [formControl]="collectionStreamControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>KF Configuration {{'kf-reporting.launched' |translate}}</mat-label>
      <mat-select [formControl]="isLaunchControl">
        <mat-option value=""> - </mat-option>
        <mat-option value="true"> Yes </mat-option>
        <mat-option value="false"> No </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label> {{'kf-reporting.launched' |translate}} range</mat-label>
      <mat-date-range-input [rangePicker]="picker"  [disabled]="isLaunchControl.value === 'no'" >
        <input matStartDate [formControl]="startLaunchedControl">
        <input matEndDate [formControl]="endLaunchedControl">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker ></mat-date-range-picker>
    </mat-form-field>

    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>

  </form>
</div>

